<template>
    <nav
        :class="classname"
        class="pagination-nav"
        aria-label="Pagination Navigation"
    >
        <ul class="pagination">
            <!-- first page -->
            <li
                class="page-item first-page-item"
                :data-mobileindicate="mobileConditional ? 'pages' : 'nomobile'"
            >
                <a
                    class="page-link caption-lg"
                    :class="{ active: currentPage === 1 }"
                    target="_self"
                    aria-current="page"
                    :data-mobileindicate="
                        mobileConditional ? 'pages' : 'nomobile'
                    "
                    @click="addUrlForHrefByBreakpoint(firstpageurl, $event)"
                >
                    1
                </a>
            </li>

            <!-- middle group -->
            <div v-if="totalpages > 1" class="middle-pages">
                <li
                    v-for="n in middlePages"
                    :key="n"
                    class="page-item"
                    :data-mobileindicate="
                        mobileConditional ? 'pages' : 'nomobile'
                    "
                >
                    <a
                        class="page-link caption-lg"
                        :class="{ active: n === currentPage }"
                        target="_self"
                        aria-current="page"
                        :data-mobileindicate="
                            mobileConditional ? 'pages' : 'nomobile'
                        "
                        @click="
                            addUrlForHrefByBreakpoint(
                                n === 1 ? firstpageurl : otherpagesurl + n,
                                $event
                            )
                        "
                    >
                        {{ n }}
                    </a>
                </li>
            </div>

            <!-- last page -->
            <li
                v-if="showLastPage"
                class="page-item last-page-item"
                :data-mobileindicate="mobileConditional ? 'pages' : 'nomobile'"
            >
                <a
                    class="page-link caption-lg"
                    :class="{ active: currentPage === totalpages }"
                    target="_self"
                    aria-current="page"
                    :data-mobileindicate="
                        mobileConditional ? 'pages' : 'nomobile'
                    "
                    @click="
                        addUrlForHrefByBreakpoint(
                            otherpagesurl + totalpages,
                            $event
                        )
                    "
                >
                    {{ totalpages }}
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
import defaultWebsite from "./../../defaultWebsiteScript.js";

export default {
    name: "PaginationElement",
    props: {
        totalpages: {
            type: Number,
            required: true,
        },
        firstpageurl: {
            type: String,
            required: true,
        },
        otherpagesurl: {
            type: String,
            required: true,
        },
        modulename: {
            type: String,
            required: true,
        },
        classname: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            currentPage: 1,
            mobileConditional: false,
        };
    },
    beforeMount() {
        this.setActivePage();
    },
    mounted() {
        this.mobileConditional = window.screen.width <= 1180;

        window.addEventListener("DOMContentLoaded", function () {
            defaultWebsite.primaryContentConditional(window.screen.width);
        });
    },
    computed: {
        middlePages() {
            let pages = [];
            let beforePage = this.currentPage - 1;
            let afterPage = this.currentPage + 1;
            /* const beforePage =
                this.totalpages === 1 ? this.currentPage : this.currentPage - 1;
            const afterPage =
                this.currentPage < this.totalpages
                    ? this.currentPage + 2
                    : this.totalpages; */

            switch(this.currentPage){

                //First Page
                case 1:

                    beforePage = beforePage + 1;
                    afterPage = afterPage + 2;

                break;

                //Others Page
                default:

                    beforePage = beforePage;
                    afterPage = afterPage + 1;

                break;

            }        

            for (let i = 1; i <= this.totalpages; i++) {
                pages.push(i);
            }

            let indexBefore = pages.indexOf(beforePage);
            let indexAfter = pages.indexOf(afterPage);

            // middle slice
            let sliced = pages.slice(indexBefore, indexAfter);

            // remove the nPrimeiro e nUltimo
            const middle = sliced.filter(
                (n) => ![1, this.totalpages].includes(n)
            );

            return middle;
        },
        showLastPage() {
            return this.totalpages > 1;
        },
    },
    methods: {
        setActivePage() {
            const path = window.location.pathname.split("/").filter(Boolean);
            const pagePart = path.find((value) => value.includes("page="));
            this.currentPage = pagePart
                ? parseInt(pagePart.replace("page=", ""))
                : 1;
        },
        addUrlForHrefByBreakpoint(url, element) {
            return !this.mobileConditional
                ? window.location.replace(url)
                : defaultWebsite.primarySidebarConditional(
                      element,
                      "mobileconditional",
                      url
                  );
        },
    },
};
</script>
